export default {
  useBreadcrumb: true, // 是否显示面包屑
  useMultipleNav: false, // 是否使用多导航标签
  useKeepAlive: false, // 使用keep-alive
  useHeader: true, // 使用顶部导航
  useSidebar: true, // 使用左侧导航
  layout: 'side', // 整体布局
  navbarBackground: 'default', // 顶部导航背景色
  sidebarBackground: 'default', // 左侧菜单背景色
  themeColors: {
    primary: '#007af5',
    success: '#67c23a',
    warning: '#e6a23c',
    danger: '#f56c6c',
    error: '#f56c6c',
    info: '#909399',
  },
  textColors: {
    primary: '#111111',
    regular: '#323232',
    secondary: '#909399',
    placeholder: '#C2C6CC',
    disabled: '#86909C',
  },
};
